import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, LOCALE_ID, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { Router, provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import * as Sentry from '@sentry/angular';

import { apiInterceptor } from '@app/interceptors/api.interceptor';
import { authInterceptor } from '@app/interceptors/auth.interceptor';

import { routes } from './app.routes';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        { provide: LOCALE_ID, useValue: 'it' },
        provideRouter(routes, withViewTransitions(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
        provideHttpClient(withInterceptors([apiInterceptor, authInterceptor])),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        // @deprecated — workaround required by @sentry/angular v8. Remove when TraceService initialization is handled natively by the SDK.
        {
            provide: APP_INITIALIZER,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
    ],
};
